import { render, staticRenderFns } from "./WhoIAmSection.vue?vue&type=template&id=fdde1676&lang=pug&"
import script from "./WhoIAmSection.vue?vue&type=script&lang=js&"
export * from "./WhoIAmSection.vue?vue&type=script&lang=js&"
import style0 from "./WhoIAmSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports